import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalMarriage: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M12.475 12.05a5.525 5.525 0 1 0-5.507-5.082 5.525 5.525 0 1 0 5.065 5.065c.145.011.293.017.442.017Zm-.442-.018a5.526 5.526 0 0 1-5.065-5.064 5.526 5.526 0 0 1 5.065 5.065Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
